module.exports = __webpack_public_path__ + "img/bell_4.34ac1a78.jpg";